<template>
    <v-row class="box-border">
        <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="2">
            <div class="text-center">
                <v-icon class="text-h1">mdi-cart-outline</v-icon>
                <p class="text-h5 font-weight-bold mt-5 black--text">Your Cart is Empty</p>
                <p class="grey--text mt-5">Looks like you haven't added anything to your cart yet.<br>Start shopping to fill it up!</p>
                <v-btn class="mt-5" :style="theme" to="/store">Continue Shopping</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>